import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class LayoutService {
  private showFooterSubject = new BehaviorSubject<boolean>(true);
  private showHeaderSubject = new BehaviorSubject<boolean>(true);

  showFooter$ = this.showFooterSubject.asObservable();
  showHeader$ = this.showHeaderSubject.asObservable();

  setShowFooter(value: boolean) {
    this.showFooterSubject.next(value);
  }

  setShowHeader(value: boolean) {
    this.showHeaderSubject.next(value);
  }
}
